module.exports = __webpack_public_path__ + "img/bb0e5a1e19ae30f06fec399e01438c1f.svg";